const Container = ({ children }: { children: React.ReactNode }) => {
    return <div className="max-w-1920 px-15 mx-auto w-full">{children}</div>;
};

export default Container;
